import PropTypes from 'prop-types';
import React from 'react';

import Input from '../../../common/input';
import Modal from '../../../common/Modal';
import Select from '../../../common/select';
import Textarea from '../../../common/textarea';
import { ECOMMERCE_INTEGRATION_ACTION, INVENTORY_ACTIONS } from '../constants';
import CancelButton from '../../../common/buttons/cancelButton';
import { inputParseFn } from '../../../common/helpers/inputs';

const inventoryActions = INVENTORY_ACTIONS.filter(action => action.value !== ECOMMERCE_INTEGRATION_ACTION);

const InventoryModal = (props) => {
  const {
    close,
    product,
    submitting,
    stopPropagationAndSubmit,
  } = props;

  return (
    <Modal close={close} showCloseButton title={`Edit Inventory – ${product.name}`}>
      <div className="s-v2 u-ph+ u-pt u-pb+">
        <div className="layout layout--large">
          <form onSubmit={stopPropagationAndSubmit}>
            <fieldset disabled={submitting}>
              <div className="layout__item">
                <span className="c-label-new u-fontsize-small">
                  Current Inventory Count: {product.inventory}
                </span>
              </div>
              <div className="layout__item u-1/2-medium-and-up">
                <span className="c-label-new">New Inventory Count</span>
                <div className="layout layout--middle">
                  <div className="layout__item">
                    <Input
                      className="c-input c-input--border c-input--v3"
                      name="quantity"
                      type="number"
                      parse={inputParseFn}
                    />
                  </div>
                </div>
              </div>

              <div className="layout__item u-1/2-medium-and-up">
                <span className="c-label-new">Reason for change</span>
                <Select
                  name="action"
                  className="c-select c-select--v3"
                  empty="Select a reason"
                  options={inventoryActions}
                />
              </div>

              <div className="layout__item u--mt">
                <span className="c-label-new">Notes</span>
                <Textarea
                  className="c-input c-input--border c-input--v3"
                  name="description"
                  type="text"
                  placeholder="Enter notes"
                />
              </div>
              <div className="u-text-right u-mb+">
                <CancelButton
                  onClick={close}
                  content="Cancel"
                />
                <button
                  type="submit"
                  className="c-btn u-width-120 u-ml-"
                >
                  <span className="c-btn__text">Save</span>
                </button>
              </div>
            </fieldset>
          </form>
        </div>
      </div>
    </Modal>
  );
};

InventoryModal.propTypes = {
  close: PropTypes.func.isRequired,
  stopPropagationAndSubmit: PropTypes.func.isRequired,
  product: PropTypes.object.isRequired,
  submitting: PropTypes.bool.isRequired,
};

export default InventoryModal;
